import styled, { css } from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'

export const TabsWrapper = styled(Flex)`
  width: 100%;
  gap: 15px;
  margin-left: 15px;
`
export const TabItem = styled.div(
  props => css`
    padding: 14px 20px;
    font-weight: 600;
    font-size: 16px;
    color: ${COLORS.GREY_T_50};
    &:hover {
      cursor: pointer;
    }
    ${props.isActive &&
    css`
      border-bottom: 3px solid #5265dd;
      color: #5265dd;
    `};
  `
)
